export enum StorageVariables {
  TermsConditionsId = 'terms_conditions_id',
  XHohrEtag = 'x-hohr-etag',
  Language = 'language_id',
  UploadTutorialCompleted = 'upload_tutorial_completed',
  InvitationCode = 'invitation-code',
  InvitationId= 'invitation-id',
  LastLoggedInEmail = 'last-logged-in-email',
  RegistrationData = 'registration-data',
}
